// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__b8Otl","layout-top":"Layout_layout-top__cI4fW","layout-content":"Layout_layout-content__bZj_q","mod-home":"Layout_mod-home__Q8b3H"};